<div class="breadcrumb" *ngFor="let breadcrumb of breadcrumbs">
  <span class="breadcrumb__label" (click)="redirect(breadcrumb)">{{breadcrumb.label}}</span>
  <span class="breadcrumb__chevron"> > </span>
</div>
